var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8401 5.98847C24.2062 6.48384 23.6198 7.06972 23.0665 6.79893C21.4152 5.99075 19.5684 5.35826 17.5842 4.94128C17.8419 5.61071 17.9831 6.33794 17.9831 7.09817C17.9831 10.4153 15.2941 13.1043 11.977 13.1043C8.65991 13.1043 5.97087 10.4153 5.97087 7.09817C5.97087 6.33791 6.11212 5.61064 6.36982 4.94118C4.38559 5.35814 2.53876 5.99061 0.8874 6.79878C0.33411 7.06956 -0.252276 6.48367 0.113874 5.9883C2.79898 2.35563 7.11285 0 11.9769 0C16.841 0 21.155 2.3557 23.8401 5.98847ZM11.977 10.9203C14.0879 10.9203 15.7991 9.20905 15.7991 7.09817C15.7991 4.98729 14.0879 3.27608 11.977 3.27608C9.86613 3.27608 8.15492 4.98729 8.15492 7.09817C8.15492 9.20905 9.86613 10.9203 11.977 10.9203Z",
    fill: "#00C7E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/Views_icon.97b5f8ac909b485453cd7a60cf30da62.svg";
export { ForwardRef as ReactComponent };